import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {
  IndeterminateCheckbox,
  IndeterminateAllCheckbox,
} from '../../common/mailFilters';
import DeleteIcon from '../../icons/DeleteIcon';
import MailTable from '../../common/mailTable';

export const externalUsersColumns = (props) => [
  {
    'Header': 'NOMBRE',
    'accessor': 'name',
  },
  {
    'Header': 'CORREO',
    'accessor': 'email',
  },
  {
    'Header': 'ESTADO',
    'accessor': 'status',
    'defaultCanFilter': true,
    'Filter': IndeterminateAllCheckbox,
    'filter': 'external',
    'Cell': ({row}) => {
      const {status} = row.original;
      return (
        <IndeterminateCheckbox
          checked={status === 'S'}
          index={row.index}
          userType="external"
        />
      );
    },
  },
  {
    'id': 'actions',
    'Header': 'ACCIONES',
    'Cell': ({row}) => {
      const {email, name, mailGroup} = row.original;
      return (
        <DeleteIcon username={name} email={email} group={mailGroup} dataType="external" />
      );
    },
  },
];

class ExternalUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {'allChecks': false};
  }

  renderLoaderOrUsers = () => {
    const {loading, externalUsersList, group, disabled} = this.props;
    const {allChecks} = this.state;
  
    if (loading) {
      return (
        <Table striped className="toyota-grid">
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="100%">
                <Loader active inline="centered" content="Ejecutando" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }

    return (
      <MailTable
        list={externalUsersList}
        group={group}
        isusersList={true}
        userType="external"
        disabled={disabled}
        allChecks={allChecks}
        columnsTableWithProps={externalUsersColumns}
      />
    );
  };

  render() {
    return (
      <Card raised fluid>
        {this.renderLoaderOrUsers()}
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'externalUsersList': state.externalUsers.list,
    'loading': state.externalUsers.loading,
    'disabled': state.externalUsers.disabled,
  };
};

const {fetchInternalUsersByGroup} = Actions;

export default connect(mapStateToProps, {
  fetchInternalUsersByGroup,
})(ExternalUsers);
